import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { getEmployeesQueryKey } from "modules/settings/lib/employeesQuery"
import { DataResponse, EmployeeResponseData, UpdateEmployeeCompanyAccessInput } from "schema"

type Response = DataResponse<EmployeeResponseData>
type Props = UpdateEmployeeCompanyAccessInput & {
  employeeId: string
}

export function useUpdateEmployeeCompanyAccessMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ employeeId, isManager, companyIds }: Props) => {
      const response = await axios.put<Response>(
        `/permissions/employee/${employeeId}/company-access`,
        {
          isManager,
          companyIds,
        },
      )

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [getEmployeesQueryKey().at(0)] })
    },
  })
}
